let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lMVMY")).then(() => parcelRequire('2VLbE'));